<template>
  <section
    id="screenshots1"
    class="hide-overflow white py-5"
  >
    <v-layout row wrap>

      <v-flex xs12>
        <v-container grid-list-xl>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="text--lighten-2" color="#97BE0D">pets</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-xs-center">How does it work?</div>
                </v-card-title>
                <v-card-text class="text-xs-center">
                  Choose a friend or a cause and download the app to your smartphone. You get directly news from the
                  field. And please don’t forget to tell it further to your friends.
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="text--lighten-2" color="#97BE0D">mobile_friendly</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-xs-center">Support the activity you like most.</div>
                </v-card-title>
                <v-card-text class="text-xs-center">
                  There is nobody but us who is taking care of the sleddogs in Eastern Greenland. They depend on our
                  help. Please choose your project you want to support. Each donation helps.
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="text--lighten-2" color="#97BE0D">euro_symbol</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-xs-center display-1">Donate easy online</div>
                </v-card-title>
                <v-card-text class="text-xs-center">
                  Choose your personal friend or cause and use the app for your support From 5 $ per month Already with
                  one Dollar you are with your friend. Choose your amount you want to dedicate. If 5 $, 10 $ or 20 $ -
                  you are a valuable friend.
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex
        xs12
        md6
        offset-md3
        align-content-space-between
        layout
        pa-5
        wrap
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md12
          >
            <h2 class="display-1 v-heading mb-3 font-weight-light text-xs-center text-green">What we stand for</h2>
            <p>
              The animal welfare association Robin Hood sees its’ tasks not simply in animal welfare but also in animal
              rights work. Animals are not only in need of our protection, but also require rights and the preservation
              of
              these. Every living being has a right for at least these following freedoms. Freedom from hunger and
              thirst,
              from suffering, pain and from fear, freedom to behave naturally and freedom to not live imprisoned.
            </p>
            <ul>
              <li>
                On the one hand, we see our task in helping individual animals, but on the other hand, also, to cause
                political changes and improvements. This is a path of trial and tribulation, but it is the only way to
                make
                a permanent change and provide safety and rights to animals on a larger scale.
              </li>
              <li>
                We believe, that educational work in school and other public institutions is of vital importance. People
                need to know what harm they cause to animals if they treat them badly, if they abandon or release them,
                but
                also how to treat them properly.
              </li>
              <li>
                Robin hood helps animals domestically, but also abroad, using active projects and political campaigns.
              </li>
              <li>
                Robin Hood and its’ representatives try to live a sustainable life. Vegetarianism and veganism are not
                just
                empty words. Especially the so-called livestock animals and their fate are extremely important to us.
              </li>
              <li>
                We chose the following slogan for Robin Hood, as we are of the opinion, that each day, each hour and
                each
                minute is the right one to help animals and to stand up for them, as they only have us as their
                emissaries
                <b>„The time is always right to do what is right.“</b> (Martin Luther King, Jr.)
              </li>
            </ul>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        md6
      >
        <v-img
          src="/img/guest/5.jpg"
        />
      </v-flex>

      <v-flex
        xs12
        md6
        align-content-space-between
        layout
        pa-5
        wrap
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md6
          >
            <h2 class="display-1 v-heading mb-3 font-weight-light text-xs-center text-green">
              The dogs need all help available.
            </h2>
          </v-flex>
        </v-layout>

      </v-flex>

      <v-flex
        xs12
        md6
        offset-md3
        align-content-space-between
        layout
        pa-5
        wrap
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md12
          >
            <p class="text-xs-center">
              Marion Löcker, founder of Robin Hood - Animal Welfare
            </p>
            <h2 class="display-1 v-heading mb-3 font-weight-light text-xs-center text-green">
              THANK YOU!
            </h2>
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
  </section>
</template>

<script>
  export default {
    name: 'GuestAbout',
  };
</script>

<style scoped>
  .text-green {
    color: #1DB100 !important;
  }
</style>
